/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import { withRouter } from 'react-router-dom'

import {
  BulkFileUploader
} from '../components'

class FilesUpload extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      upload: false
    }
  }

  render() {
    let fileTypes = [
      {
        value: "RmlsZVR5cGVOb2RlOmY2MTRiMjAyLWRmZWUtNDRmMC1iYmYxLTEwMjk5ODZmMGE0OQ==",
        label: "Proof of payment"
      },
      {
        value: "RmlsZVR5cGVOb2RlOmRjZWY3NjBiLTc1ZjItNGRiMS05OGE1LTY0ZmYyMTEwMTZhZg==",
        label: "Loan Application Retail Invoice"
      },
      {
        value: "RmlsZVR5cGVOb2RlOjEwYTQ0MGE1LWM0ZjctNGQ1Yi1hYTBkLWNiNjc3ZWQwNTg0Ng==",
        label: "Payslip"
      },
      {
        value: "RmlsZVR5cGVOb2RlOjdlNGRkY2MxLTlkYTktNGI0NC1iZmZiLTU4YjBjNzA4ZjlmZQ==",
        label: "Loan application consolidation statement"
      },
      {
        value: "RmlsZVR5cGVOb2RlOjIwZTQ5M2QxLTdkZmEtNDllYy1iMzA4LWU2ZTBmYzNkZmU2OA==",
        label: "Loan application"
      },
      {
        value: "RmlsZVR5cGVOb2RlOjI2NDIzYWM4LTExODYtNGEzMy1hNDgxLWU5ZmFkNGQxZTgxOA==",
        label: "Form - Application - Association Member"
      },
      {
        value: "RmlsZVR5cGVOb2RlOjY3NWIzYWVhLWM1ZmMtNDc5MC04Njg4LTRlODA0MjUyZDFlNQ==",
        label: "Form - Application - Debt assistance"
      },
      {
        value: "RmlsZVR5cGVOb2RlOmE4ZTZhMTcwLTVkOWEtNDlhMi04Yjk1LWRmNGRkNWI0NWIwMg==",
        label: "Form - Application - Funeral Cover - Extended Family Members"
      },
      {
        value: "RmlsZVR5cGVOb2RlOjZiNmQ0N2EzLTgzZDEtNDVkYi05OGY2LTZjZTMxYTc3NjJhNw==",
        label: "Form - Application - Funeral Cover - Voluntary"
      },
      {
        value: "RmlsZVR5cGVOb2RlOmYzYTBkMTE3LWQ3MzUtNDBlMC1hNzE2LTIxMzU0OTgzMWM4Zg==",
        label: "Form - Application - Investments"
      },
      {
        value: "RmlsZVR5cGVOb2RlOjgwYjBiZWYyLTNjNmQtNGVkNS1iMTFlLWEwYmNjMzE5MjMyNQ==",
        label: "Form - Application - Policy assistance"
      },
      {
        value: "RmlsZVR5cGVOb2RlOjMwYjNiZTA2LWJkMmYtNDNlNy1iMmQ5LTI3NDQ4MDkwYTJmNg==",
        label: "Form - Application - Rewards"
      },
      {
        value: "RmlsZVR5cGVOb2RlOmExYTY5YzkxLTFlZjItNDBjNi05ODU0LTY5YWVjMjBkNGUxOA==",
        label: "Form - Investment Beneficiaries"
      },
      {
        value: "RmlsZVR5cGVOb2RlOmZlZGVhOGVjLTJlNmMtNDZiMC05OGI1LTNiYzJjZWQwYWIzOA==",
        label: "Form - Power of Attorney"
      },
      {
        value: "RmlsZVR5cGVOb2RlOmQ1NzAxNGM3LTUyMjMtNDY2NS1hODBmLTk1NzUzNzQwNTFlZg==",
        label: "Form - Transfer of client funds to the Association"
      }
    ]
    
    return (
      <div className="stage-main slds-size_1-of-1"
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.stopPropagation() // stops the browser from redirecting by default
        e.preventDefault()
      }}>
        <BulkFileUploader
          heading="Upload files"
          fileTypes={fileTypes}
          className="slds-size_2-of-3 slds-m-around_xx-large"
          onCancel={() => this.props.history.push("/os/operations/general/files")}
        />
      </div>
    )
  }
}

export default withRouter(FilesUpload)



// WEBPACK FOOTER //
// ./src/containers/FilesUpload.js